import {  post } from "../../service/api";

const ForceSettle = async (merchantId,merchantSettleId) => {
    try {
        const response = await post(`/merchant/${merchantId}/merchantSettle/${merchantSettleId}/forceSettle`);
        return response;
    } catch (error) {
        console.error('Error ForceSettle:', error);
        throw error;
    }
};

export default ForceSettle;